import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f3b5c42"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "New CyberSquade"),
  /*#__PURE__*/_createElementVNode("p", { class: "card-slogan" }, "No slogan")
], -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "card-count" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-button" }, [
  /*#__PURE__*/_createElementVNode("a", {
    style: {"display":"none"},
    href: "#rename",
    class: "button button-small secondary"
  }, "Rename"),
  /*#__PURE__*/_createElementVNode("a", {
    style: {"display":"none"},
    href: "#slogan",
    class: "button button-small secondary"
  }, "Slogan"),
  /*#__PURE__*/_createElementVNode("button", {
    style: {"display":"none"},
    class: "button button-small third"
  }, "Disband")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_New1057ybersquadSlot = _resolveComponent("NewСybersquadSlot")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "col-12 col-12-md col-12-lg card card-squade"
  }, [
    _createElementVNode("button", {
      disabled: _ctx.disabledBtn,
      class: "button button-small button-create primary",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.approvedForAll && _ctx.approvedForAll(...args)))
    }, " Create ", 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, key) => {
        return _createVNode(_component_New1057ybersquadSlot, {
          key: key,
          id: key,
          chosenTokens: _ctx.chosenTokens,
          newCyberSquadeContainerId: _ctx.id,
          onClickBtn: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal($event)))
        }, null, 8, ["id", "chosenTokens", "newCyberSquadeContainerId"])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.selectedЕokens) + " $CyberCola/Day", 1),
    _hoisted_6,
    _withDirectives(_createVNode(_component_ModalWindow, {
      onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeModal = false)),
      newCybersquadSlotId: _ctx.choiceBlockId,
      newCyberSquadeContainerId: _ctx.id,
      onTokenChosen: _ctx.onTokenChosen,
      allowedTokens: _ctx.allowedTokens,
      onClickTokesModal: _ctx.checkingТumberOfTokens
    }, null, 8, ["newCybersquadSlotId", "newCyberSquadeContainerId", "onTokenChosen", "allowedTokens", "onClickTokesModal"]), [
      [_vShow, _ctx.activeModal]
    ])
  ], 8, _hoisted_1))
}